

document.addEventListener('DOMContentLoaded', function () {

     const cartWrap = document.querySelector('.main-cart-wrapper');

     if(!cartWrap.classList.contains('empty-cart')){
          // Fetch Products
          function fetchProducts(ProductPage) {
               fetch(`/products.json?limit=250&page=${ProductPage}`)
                    .then(response => response.json())
                    .then(res => {
                         allCartProductsData = res;
                         setGiftItem(allCartProductsData)
                         renderSelectedProducts(allCartProductsData)
                    });
          }
          fetchProducts(ProductPage);
     
          var mainCartReviewsCarousel = new Swiper(".mtc", {
               slidesPerView: 1,
               spaceBetween: 10,
               touchAngle: 65,
               autoHeight: true,
               loop: true,
               navigation: {
                    nextEl: ".mtc__next",
                    prevEl: ".mtc__prev",
               }
          });
          
     }


});